import { Provider } from '@angular/core';
import { MODAL_REGISTRY } from '@features/modals/modal-registry.token';
import { RewardsRequirementsModalComponent } from '@features/rewards/modals/rewards-requirements-modal/rewards-requirements-modal.component';
import { RewardsRakebackModalComponent } from '@features/rewards/modals/rewards-rakeback-modal/rewards-rakeback-modal.component';

export function provideRewardsModals(): Provider[] {
  return [
    { provide: MODAL_REGISTRY, useValue: { key: 'RewardsRequirementsModal', component: RewardsRequirementsModalComponent }, multi: true },
    { provide: MODAL_REGISTRY, useValue: { key: 'RewardsRakebackModal', component: RewardsRakebackModalComponent }, multi: true },
  ];
}
